import NationalText from './NationalText';
import { getNationalText } from './utils';

export { getNationalText };
export default NationalText;
